  <template>
  <div class="control-section">
    <div  class="h100vh-140">
      <ejs-grid ref="grid" :dataSource="data" height="calc(100% - 0px)" :rowDeselected="getChooseCount" :pageSettings="page" :rowSelected="getChooseCount" :allowReordering="true" :allowResizing="true" >
        <e-columns>
          <e-column type='checkbox' headerText='mcsid' width='66' textAlign='Center'  minWidth='10px'></e-column>
          <e-column field='profileId' :headerText='$t("DNN.profileId")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
          <e-column field='profileName' :headerText='$t("DNN.profileName")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
          <e-column field='dnnName' :headerText='$t("DNN.dnnName")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
          <e-column field='defaultIndicator' :headerText='$t("DNN.defaultIndicator")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
          <!-- <e-column field='lboRoamingAllowed' :headerText='$t("DNN.lboRoamingAllowed")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column> -->
          <e-column field='ambrUp' :headerText='$t("DNN.ambrUp")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
          <e-column field='ambrDown' :headerText='$t("DNN.ambrDown")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
          <e-column field='chargeChars' :headerText='$t("DNN.chargeChars")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
          <e-column field='pduSessionType' :headerText='$t("DNN.pduSessionType")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
          <e-column field='dftPduSessionType' :headerText='$t("DNN.dftPduSessionType")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
          <e-column field='sscMode' :headerText='$t("DNN.sscMode")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
          <e-column field='dftSscMode' :headerText='$t("DNN.dftSscMode")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
          <e-column field='fiveQi' :headerText='$t("DNN.fiveQi")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
          <e-column field='fiveQiPriorityLevel' :headerText='$t("DNN.fiveQiPriorityLevel")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
          <e-column field='pl' :headerText='$t("DNN.pl")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
          <e-column field='pev' :headerText='$t("DNN.pev")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
          <e-column field='pec' :headerText='$t("DNN.pec")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref='pager' @click='qryProfiles()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
    </div>
    <CustomDialog ref="addProfilePage" :element="dialog.element.eleAddProfile" :styles="dialog.styles" :messages="dialog.messages.addProfile" >
      <template v-slot:dialog-content>
        <AddProfileForm ref="addProfile"></AddProfileForm>
      </template>
    </CustomDialog>
    <CustomDialog ref="modProfilePage" :element="dialog.element.eleModProfile" :styles="dialog.styles" :messages="dialog.messages.modProfile" >
      <template v-slot:dialog-content>
        <ModProfileForm ref="modProfile"></ModProfileForm>
      </template>
    </CustomDialog>
    <Notification ref="notification" :position="position" timeOut="2000"></Notification>
    <DialogConfirm ref="dialogConfirm" :title='$t("Common.confirm")' :content='$t("PDN.delConfirm")' :onOk="onClickDelOk"></DialogConfirm>
    <CustomDialog ref='dialogListPage' :element='dialog.element.eleDialogList' :styles='dialog.stylesDialogList'>
      <template v-slot:dialog-content>
        <DialogList ref='dialogList'></DialogList>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import { Reorder, Resize } from "@syncfusion/ej2-vue-grids";
import CustomDialog from "../../../common/CustomDialog";
import Notification from "../../util/tipDialog/Notification";
import DialogConfirm from "../../util/tipDialog/DialogConfirm";
import DialogList from "../../util/tipDialog/DialogList";
import AddProfileForm from "./dialog/AddProfileForm";
import ModProfileForm from "./dialog/ModProfileForm";
import ajaxUrl from "../../data/ajaxUrl";
import { log } from 'util';
import { EventBus } from '../../../../plugins/eventBus';

export default {
  name: "DNNProfileTable",
  components: {
    CustomDialog,
    Notification,
    DialogConfirm,
    AddProfileForm,
    ModProfileForm,
    DialogList,
  },
  data() {
    return {
      data: {},
      page: {
        pageNo: 1,
        pageSize: 15,
        totalCount: 0,
        pageCount: 0
      },
      ne: {
        neid: '',
        netype: "",
        neversion: ""
      },
      chooseCount: 0,
      dialog: {
        styles: {
          width: "810px",
          height: "760px",
          visible: false,
          model: true
        },
        stylesGroupList: {
          width: "30%",
          height: "80%",
          visible: false,
          model: true
        },
        stylesSearch: {
          width: "30%",
          height: "30%",
          visible: false,
          model: true
        },
        stylesDialogList: {
          width: "30%",
          height: "50%",
          visible: false,
          model: true
        },
        element: {
          eleAddProfile: {
            target: this.$refs.addProfile,
            refName: "eleAddProfile",
            buttonGroup: [
              {
                click: this.saveAddProfile,
                buttonModel: { content: this.$t("PDN.confirm"), isPrimary: true }
              },
              {
                click: this.closeAddProfilePage,
                buttonModel: { content: this.$t("PDN.cancel") }
              }
            ],
            title: this.$t("PDN.addProfile"),
            isClose: true
          },
          eleModProfile: {
            target: this.$refs.modProfile,
            refName: "eleModProfile",
            buttonGroup: [
              {
                click: this.saveModProfile,
                buttonModel: { content: this.$t("PDN.confirm"), isPrimary: true }
              },
              {
                click: this.closeModProfilePage,
                buttonModel: { content: this.$t("PDN.cancel") }
              }
            ],
            title: this.$t("PDN.modProfile"),
            isClose: true
          },
          eleDialogList: {
            target: this.$refs.dialogList,
            refName: 'dialogList',
            buttonGroup: [
              {
                click: this.closeDialogListPage,
                buttonModel: { content: this.$t("PDN.confirm") }
              }
            ],
            title: this.$t("PDN.logger"),
            isClose: true,
          },
        },
        messages: {
          addProfile: {
            title: this.$t("PDN.addProfile"),
          },
          modProfile: {
            title: this.$t("PDN.modProfile"),
          }
        }
      },
      position: { X: "Center", Y: "Top" },
      descPDU: {
        0: this.$t("DNN.pduType0"),
        1: this.$t("DNN.pduType1"),
        2: this.$t("DNN.pduType2"),
        3: this.$t("DNN.pduType3"),
        4: this.$t("DNN.pduType4"),
      },
      descSscMode: {
        0: this.$t("DNN.sscMode0"),
        1: this.$t("DNN.sscMode1"),
        2: this.$t("DNN.sscMode2"),
      },
      descPev: {
        0: this.$t("DNN.enabled"),
        1: this.$t("DNN.disabled"),
      },
      descPec: {
        0: this.$t("DNN.enabledPec"),
        1: this.$t("DNN.disabledPec"),
      },
      descDefaultIndicator: {
        0: this.$t("DNN.notDefaultIndicator0"),
        1: this.$t("DNN.defaultIndicator1"),
      },
      descLboRoamingAllowed: {
        0: this.$t("DNN.notAllowed"),
        1: this.$t("DNN.lboRoamingAllowed1"),
      },
      descCommonError: {
        0: this.$t("DNN.commonError0"),
        1: this.$t("DNN.commonError1"),
        2: this.$t("DNN.commonError2"),
        3: this.$t("DNN.commonError3"),
        4: this.$t("DNN.commonError4"),
        5: this.$t("DNN.commonError5"),
        6: this.$t("DNN.commonError6"),
        7: this.$t("DNN.commonError7"),
        8: this.$t("DNN.commonError8"),
        9: this.$t("DNN.commonError9"),
        10: this.$t("DNN.commonError10"),
        11: this.$t("DNN.commonError11"),
        12: this.$t("DNN.commonError12"),
        13: this.$t("DNN.commonError13"),
        14: this.$t("DNN.commonError14"),
        15: this.$t("DNN.commonError15"),
      },
    };
  },
  provide: {
    grid: [Reorder, Resize]
  },
  methods: {
    getGridData(ne) {
      this.ne.neid = ne.data.id;
      this.ne.netype = ne.data.neType;
      this.ne.neversion = ne.data.neVersion;
      this.qryProfiles();
    },
    isChooseNe() {
      if (this.ne.neid === "") {
       EventBus.$emit('toast', {type: 'warning', content: this.$t("LteUser.pleaseSelectNE")});
       return false;
      }
      return true;
    },
    getCheckedDatas(selectOnly = false) {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t("PDN.pleaseSelectDatas")});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t("PDN.pleaseSelectOneData")});
        return false;
      }
      return selectedRecords;
    },
    getCheckedKeys(selectOnly = false) {
      // x-> false: 不支持多选   true: 支持多选
      const profileId = [];
      const checkedData = this.getCheckedDatas(selectOnly);
      for (let i = 0; i < checkedData.length; i++) {
        profileId.push(checkedData[i].profileId);
      }
      return profileId.length === 0 ? false : profileId;
    },
    getChooseCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.chooseCount = selectedRecords.length;
    },
    responseIsFailed(response) {
      console.log("responseIsFailed",response)
      console.log("responseIsFailed data",response.data)
      console.log("responseIsFailed resultVal",response.data.resultVal)
      if (!response) {
        console.log("response error");
        return true;
      }
      if (!response.data) {
        console.log("response.data error");
        return true;
      }
      if (!response.data.resultVal) {
        console.log("response.data.resultVal error");
        return true;
      }
      if (0!==response.data.resultVal.result) {
        EventBus.$emit('toast', {type: 'warning', 
          content: response.data.errorString
        });
        return true;
      }
      return false;
    },
    openAddProfilePage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.addProfile.getJson(this.ne, (response) => {
        if(response.data.errorCode !== "0") {
        EventBus.$emit('toast', {type: 'warning', content: response.data.errorString});
        return;
        }
        this.$refs.addProfilePage.show();
      });
    },
    closeAddProfilePage() {
      this.$refs.addProfilePage.clear();
      this.$refs.addProfilePage.close();
    },
    saveAddProfile() {
      this.$refs.addProfile.saveProfile(this.ne, (response) => {
        if (this.responseIsFailed(response)) {
          return;
        }
        this.closeAddProfilePage();
        EventBus.$emit('toast', {type: 'success', content: this.$t("DNN.addProfileSuccess")});
        this.qryProfiles();
      });
    },
    getKey(obj, value) {
      for(let key in obj){
        if (value === obj[key]) {
          return Number(key);
        }
      }
    },
    openModProfilePage() {
      if (this.isChooseNe() === false) {
        return;
      }
      const checkedDatas = this.getCheckedDatas();
      if (checkedDatas) {
         const record = checkedDatas.map((item) => {
           console.log("item",item.pduSessionType)
          return {
            ...item,
            "pduSessionType":item.pduSessionType,
            "sscMode":item.sscMode,
            "dftPduSessionType": this.getKey(this.descPDU, item.dftPduSessionType),
            "dftSscMode": this.getKey(this.descSscMode, item.dftSscMode),
            "pev": this.getKey(this.descPev, item.pev),
            "pec": this.getKey(this.descPec, item.pec),
            "defaultIndicator": this.getKey(this.descDefaultIndicator, item.defaultIndicator),
            // "lboRoamingAllowed": this.getKey(this.descLboRoamingAllowed, item.lboRoamingAllowed),

          }
        });

        this.$refs.modProfile.getJson(this.ne, record, (response) => {
          if(response.data.errorCode !== "0") {
          EventBus.$emit('toast', {type: 'warning', content: response.data.errorString });
          return;
          }
          this.$refs.modProfilePage.show();
        });
      }
    },
    closeModProfilePage() {
      this.$refs.modProfilePage.clear();
      this.$refs.modProfilePage.close();
    },
    saveModProfile() {
      this.$refs.modProfile.saveProfile(this.ne, (response) => {
        if (this.responseIsFailed(response)) {
          return;
        }
      this.closeModProfilePage();
      EventBus.$emit('toast', {type: 'success', content: this.$t("DNN.modProfileSuccess")});
      this.qryProfiles();
      });
    },
    delProfiles() {
      if (this.getCheckedKeys(true)) {
        this.$refs.dialogConfirm.show();
      }
    },
    onClickDelOk() {
      const delKeys = this.getCheckedKeys(true);
      const params = {
        vo: {
          profileIds: delKeys,
        },
        info: {
          msgid: "28674",
          neid: this.ne.neid,
        }
      };
      this.$axios.post(ajaxUrl.delCommonD, params).then(response => {
        if (!response) {
          console.log("delDnnProfile response error");
          return;
        }
        if (!response.data) {
          console.log("delDnnProfile response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("delDnnProfile response.data.resultVal null error");
          return;
        }
        const resultVal = response.data.resultVal.resultCode;
        const resultCodeStr = response.data.resultVal.resultCodeStr;
        const operList = [];
        for (let i = 0; i < delKeys.length; i++) {
          operList.push({
            operObj: delKeys[i],
            operResult: resultCodeStr[i],
            operCode:resultVal[i]
          });
        }
        console.log("resultVal",resultVal[0])
        console.log("operList",operList)
        this.$refs.dialogList.addUDMOperetionResultList(operList);
        this.$refs.dialogList.setTotalCount(delKeys.length);
        this.$refs.dialogListPage.show();
        // EventBus.$emit('toast', {type: 'success', content: this.$t("DNN.delProfileSuccess")});
        this.qryProfiles();
      });
    },
    closeDialogListPage() {
      this.$refs.dialogListPage.clear();
      this.$refs.dialogListPage.close();
    },
    qryProfiles(promptSuccess=false) {
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = {
        vo: {
          flag: 0,
        },
        info: {
          msgid: "28675",
          neid: this.ne.neid,
        },
        page: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
        },
      };
      this.$axios.post(ajaxUrl.qryDnnProfile, params).then((response) => {
                          console.log("response",response);

        if (!response) {
          console.log("qryDNNProfile response error");
          return;
        }
        if (!response.data) {
          console.log("qryDNNProfile response.data error");
          return;
        }
        if (response.data.errorCode ===  'subscriber.9005') {
          this.ne.neid = '';
          this.data = [];
          this.page.pageCount = 0;
          this.page.totalCount = 0;
          EventBus.$emit('toast', {type: 'warning', content: this.$t('MCS.neOffLine')});
          return;
        }
        if (!response.data.resultVal) {
          console.log("qryDNNProfile response.data.resultVal error");
          this.data = [];
          this.page.pageCount = 0;
          this.page.totalCount = 0;          
          return;
        }
        // 当PDN模板和用户签约模板为空时，查询设备端返回0x01000000错误码，暂时规避掉该错误
        if (response.data.resultVal.result !== 0 && response.data.resultVal.result !== 0x01000000 && response.data.resultVal.result !== 1 ) {
          console.log("qryPdnProfile response.data.resultVal.result error");
        //  EventBus.$emit('toast', {type: 'warning', content: response.data.resultVal.result.toString()});          
          this.data = [];
          this.page.pageCount = 0;
          this.page.totalCount = 0;         
          return;
        }
        const res = response.data.resultVal;

        if (res) {
          if (res.dnnProfileInfo) {
            const dnnProfileInfoJson = res.dnnProfileInfo.map(item => {
            var type="";
            if(item.pduSessionType[0]==1){
              type=this.$t("DNN.pduType0")+';'
              }
            if(item.pduSessionType[1]==1){
              type=type+this.$t("DNN.pduType1")+';'
              }
            if(item.pduSessionType[2]==1){
              type=type+this.$t("DNN.pduType2")+';'
              }
            if(item.pduSessionType[3]==1){
              type=type+this.$t("DNN.pduType3")+';'
              }
            if(item.pduSessionType[4]==1){
              type=type+this.$t("DNN.pduType4")
              }
            var mode="";
            if(item.sscMode[0]==1){
              mode=this.$t("DNN.sscMode0")+';'
              }
            if(item.sscMode[1]==1){
              mode=mode+this.$t("DNN.sscMode1")+';'
              }
            if(item.sscMode[2]==1){
              mode=mode+this.$t("DNN.sscMode2")
              }

              return {
                ...item,
                "pduSessionType": type,
                "sscMode": mode,
                "dftPduSessionType": this.descPDU[item.dftPduSessionType],
                "dftSscMode": this.descSscMode[item.dftSscMode],
                "pev": this.descPev[item.pev],
                "pec": this.descPec[item.pec],
                "defaultIndicator": this.descDefaultIndicator[item.defaultIndicator],
                // "lboRoamingAllowed": this.descLboRoamingAllowed[item.lboRoamingAllowed],
              }
            });
            this.data = dnnProfileInfoJson;
          } else {
            this.data = [];
          }
          this.page.pageCount = res.page;
          this.page.totalCount = res.countRsp;
          this.page.pageCount = Math.ceil(res.countRsp / this.page.pageSize);
        }
        // if (promptSuccess) {
        //  EventBus.$emit('toast', {type: 'success', content: this.$t("DNN.qryProfileSuccess")});
        // }
      });
    }
  },
};
</script>

<style scoped>
</style>
